import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { Fragment } from 'react';

const VisualizarCategoriasCompra = ({ values }) => {
  return (
    <Grid container spacing={3} className="mb-16">
      <Grid item xs={5}>
        <b>Categoria</b>

        {values?.categorias?.map((categoria) => (
          <Fragment key={categoria?.id}>
            <TextLabel id="categoria" label="" value={`${categoria?.classe?.indice} ${categoria?.classe?.nome}`} />
          </Fragment>
        ))}
      </Grid>
      <Grid item xs={7}>
        <b>Valor (R$)</b>

        {values?.categorias?.map((categoria) => (
          <Fragment key={categoria?.id}>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id="valorBruto" label="" value={getCurrency(categoria?.valorBruto)} />
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </Grid>
  );
};

export default VisualizarCategoriasCompra;
